/**
 * @generated SignedSource<<40299dd33da1b2da6c977e7f89ecd333>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InvoiceStatus = "applied" | "unapplied" | "unset";
export type UpdateInfluencerInfoMutationInput = {
  birthday?: string | null;
  clientMutationId?: string | null;
  commonName?: string | null;
  gender?: string | null;
  invoiceNo?: string | null;
  invoiceStatus?: InvoiceStatus | null;
  profile?: string | null;
  tiktokUrl?: string | null;
  twitterUrl?: string | null;
  ytChannel?: string | null;
};
export type ProfileEditProfileMutation$variables = {
  input: UpdateInfluencerInfoMutationInput;
};
export type ProfileEditProfileMutation$data = {
  readonly updateInfluencerInfo: {
    readonly __typename: "Influencer";
    readonly profile: {
      readonly birthday: any | null;
      readonly commonName: string | null;
      readonly gender: string | null;
    };
  } | {
    readonly __typename: "UpdateInfluencerInfoError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type ProfileEditProfileMutation = {
  response: ProfileEditProfileMutation$data;
  variables: ProfileEditProfileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commonName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gender",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "birthday",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "UpdateInfluencerInfoError",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileEditProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencerInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProfileEditProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencerInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b76b58c331c2c2ad364e9efac32ecf95",
    "id": null,
    "metadata": {},
    "name": "ProfileEditProfileMutation",
    "operationKind": "mutation",
    "text": "mutation ProfileEditProfileMutation(\n  $input: UpdateInfluencerInfoMutationInput!\n) {\n  updateInfluencerInfo(input: $input) {\n    __typename\n    ... on Influencer {\n      profile {\n        commonName\n        gender\n        birthday\n        id\n      }\n      id\n    }\n    ... on UpdateInfluencerInfoError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "df4bfccfcaba4da3662794a0f5801c0b";

export default node;
